import { NavLink, Route, Routes } from "react-router-dom";
import { PageHeader } from "@/components/layout/PageHeader";
import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";
import { TcpClientsPage } from "./sources/TcpClients";
import { QrMaintWebhookPage } from "./sources/QrMaintWebhook";
import { LokiPage } from "./sources/Loki";
import { SyslogPage } from "./sources/Syslog";
import { MqttPage } from "./sources/Mqtt";

const SUB_NAV = [
  { to: "tcp", label: t("TCP-Clients") },
  { to: "qrmaint", label: t("QR.Maint Webhook") },
  { to: "loki", label: t("Loki HTTP API") },
  { to: "syslog", label: "Syslog" },
  { to: "mqtt", label: "MQTT" },
];

export function SourcesPage() {
  return (
    <div>
      <PageHeader
        title={t("Quellen")}
        description={t("Alle Ingest-Wege an einem Ort: TCP, Webhooks, Loki, Syslog, MQTT")}
      />
      <SubNav />
      <Routes>
        <Route index element={<TcpClientsPage />} />
        <Route path="tcp" element={<TcpClientsPage />} />
        <Route path="qrmaint" element={<QrMaintWebhookPage />} />
        <Route path="loki" element={<LokiPage />} />
        <Route path="syslog" element={<SyslogPage />} />
        <Route path="mqtt" element={<MqttPage />} />
      </Routes>
    </div>
  );
}

function SubNav() {
  return (
    // Mobil: horizontal scrollbare Leiste statt Umbruch/Overflow; Scrollbar versteckt.
    <div className="flex gap-1 overflow-x-auto border-b border-border px-3 py-2 [scrollbar-width:none] md:px-6 [&::-webkit-scrollbar]:hidden">
      {SUB_NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "tcp"}
          className={({ isActive }) =>
            cn(
              "shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-xs font-medium transition-colors md:py-1",
              isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:bg-muted",
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
}
